import { render } from "./MenuLinks.vue?vue&type=template&id=e6126ed8&scoped=true"
import script from "./MenuLinks.vue?vue&type=script&lang=js"
export * from "./MenuLinks.vue?vue&type=script&lang=js"

import "./MenuLinks.vue?vue&type=style&index=0&id=e6126ed8&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e6126ed8"]])

export default __exports__